/**
 * Accounts Service
 *
 * Wraps GET /api/v1/integrations/accounts — the canonical list of connected
 * ad accounts for the authenticated user (Google, Meta, TikTok).
 *
 * Tokens are never returned by the API; this only fetches metadata.
 */

import { api } from './api';

/**
 * Fetch all active connected ad accounts for the current user.
 * Returns an array of account objects:
 *   { id, provider, external_account_id, account_name, currency, sync_status, ... }
 */
export async function getConnectedAccounts({ provider = null } = {}) {
  const params = new URLSearchParams();
  if (provider) params.set('provider', provider);
  const qs = params.toString();
  const url = `/integrations/accounts${qs ? `?${qs}` : ''}`;
  const res = await api.get(url);
  return res.data?.accounts ?? res.data ?? [];
}

export default { getConnectedAccounts };
